import SchedulePositionDetails from "./SchedulePositionDetails";

/** Strona szczegółów pozycji harmonogramu (read-only). */
export default function SchedulePositionPage() {
  return <SchedulePositionDetails />;
}
